import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, withStyles } from '@material-ui/core';
import { Close, PriorityHigh } from '@material-ui/icons';
import Translator from '../../../../../../../translator';

class Preview extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        content: PropTypes.string,
        header: PropTypes.string,
        defaultButtons: PropTypes.array,
        buttonIds: PropTypes.array,
        closeFunc: PropTypes.func.isRequired,
        isOpen: PropTypes.bool.isRequired
    };

    static defaultProps = {
        content: '',
        buttonIds: [],
        defaultButtons: [],
        header: ''
    };

    render() {
        const { content, defaultButtons, classes, header, buttonIds, closeFunc, isOpen } = this.props;
        const buttons = buttonIds.map(id => {
            return defaultButtons.find(btn => btn.value === id).component;
        });
        return (
            <Modal open={isOpen} onClose={closeFunc}>
                <div className={classes.preview}>
                    <div className={`${classes[header]} ${classes.header}`}>
                        {Translator.translate(`generic.notification.preview.title.${header}`)}
                        {header === 'information' ? (
                            <i className={`fas fa-info fa-lg ${classes.priorityIcon}`} />
                        ) : (
                            <PriorityHigh className={classes.priorityIcon} />
                        )}
                        <Close className={classes.closeIcon} onClick={closeFunc} />
                    </div>
                    <hr />
                    <div className={classes.content} dangerouslySetInnerHTML={{ __html: content }} />
                    <hr />
                    <div className={classes.footer}>{buttons}</div>
                </div>
            </Modal>
        );
    }
}

const styles = theme => ({
    information: {
        color: theme.palette.rainbow.c007
    },
    warning: {
        color: theme.palette.warning.main
    },
    critical: {
        color: theme.palette.error.main
    },
    priorityIcon: {
        position: 'absolute',
        right: 50
    },
    closeIcon: {
        color: theme.palette.colors.grey700,
        position: 'absolute',
        right: 20
    },
    header: {
        padding: 10,
        height: 50
    },
    content: {
        padding: 10
    },
    footer: {
        padding: '0 15px 15px 0',
        height: 50,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    preview: {
        overflow: 'hidden',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10,
        width: 800,
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.colors.white
    }
});

export default withStyles(styles, { withTheme: true })(Preview);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Notification/components/Preview.js